import { EntityConfig } from './entity-registry';
import { GenericTableColumn, GenericTableAction } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../../models/GenericCRUD/Filter';

// Configuración extraída de MovementsHomeComponent
const tableColumns: GenericTableColumn[] = [
  { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
  { name: 'Fecha', active: true, type: 'date', key: 'movement_date', sort: true },
  { name: 'Banco', active: true, type: 'text', key: 'bank.name', sort: false },
  { name: 'Tipo', active: true, type: 'text', key: 'type_name', sort: true },
  { name: 'Concepto', active: true, type: 'text', key: 'concept', sort: false },
  { name: 'Método Pago', active: true, type: 'text', key: 'payment_method_label', sort: false },
  { name: 'Detalle Pago', active: true, type: 'text', key: 'payment_detail', sort: false },
  { name: 'Monto', active: true, type: 'currency', key: 'amount', sort: true },
  { name: 'Bloqueado', active: true, type: 'boolean', key: 'locked', sort: true }
];

// Formulario para Ingreso/Gasto
const formFieldsIncomeExpense: GenericFormField[] = [
  {
    name: 'type',
    type: 'select',
    label: 'Tipo',
    validations: 'required',
    optionsList: [
      { id: 'income', name: 'Ingreso' },
      { id: 'expense', name: 'Gasto' }
    ],
    singleSelection: true,
    colspan: 1
  },
  { name: 'bank_id', type: 'select', label: 'Banco', url: '/bank/all', validations: 'required', singleSelection: true, colspan: 1 },
  {
    name: 'payment_method',
    type: 'select',
    label: 'Forma de pago',
    optionsList: [
      { id: 'cash', name: 'Efectivo' },
      { id: 'card', name: 'Tarjeta' },
      { id: 'transfer', name: 'Transferencia' },
      { id: 'other', name: 'Otro' }
    ],
    singleSelection: true,
    validations: '',
    colspan: 1,
    defaultValue: 'cash'
  },
  { name: 'amount', type: 'number', label: 'Monto', validations: 'required|min:0.01', colspan: 1 },
  { name: 'movement_date', type: 'date', label: 'Fecha', validations: 'required', colspan: 1 },
  { name: 'concept', type: 'textarea', label: 'Concepto', validations: 'required', colspan: 2 },
  { name: 'reference_number', type: 'text', label: 'Número de Referencia', validations: '', colspan: 2 }
];

const tableActions: GenericTableAction[] = [
  {
    name: 'Editar',
    key: 'edit',
    form: {
      method: 'PUT',
      successTitle: 'Edición correcta',
      errorTitle: 'Error en la edición',
      fields: formFieldsIncomeExpense,
      name: 'movimiento',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      originalUpdateApiSlug: '/movement/update/{{id}}',
      updateApiSlug: '',
      originalFormTitle: 'Editar Movimiento',
      formTitle: 'Editar Movimiento',
      formButtonTitle: 'Guardar',
      width: '3xl'
    },
    completeForm: true,
    replaceAllRowOnResponse: true,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
    confirmation: false
  },
  {
    name: 'Eliminar',
    key: 'delete',
    method: 'DELETE',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
    confirmation: true,
    questionText: '¿Desea eliminar este movimiento?',
    deleteRowOnResponse: true,
    actionSlug: '/movement/delete/{{id}}'
  }
];

const filters: Filter[] = [
  {
    type: 'date-between',
    key: 'movement_date',
    operator: 'between',
    placeholder: 'Fecha'
  },
  {
    type: 'select',
    key: 'bank_id',
    operator: 'in',
    placeholder: 'Bancos',
    url: '/bank/all'
  },
  {
    type: 'select',
    key: 'type',
    operator: 'in',
    placeholder: 'Tipo',
    optionsList: [
      { id: 'income', name: 'Ingreso' },
      { id: 'expense', name: 'Gasto' },
      { id: 'transfer', name: 'Transferencia' }
    ]
  },
  { type: 'search', key: 'concept|reference_number', operator: 'like', placeholder: 'Concepto o referencia' }
];

/**
 * Configuración completa de la entidad Movimientos Caja y Banco
 */
export const movementsConfig: EntityConfig = {
  id: 'movements',
  name: 'Movimientos Caja y Banco',
  icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"/></svg>',

  tableColumns,
  formFields: formFieldsIncomeExpense,
  tableActions,
  filters,

  form: {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: formFieldsIncomeExpense,
    name: 'movimiento',
    createButtonTitle: 'Nuevo Ingreso/Gasto',
    cols: 2,
    createApiSlug: '/movement/store',
    formTitle: 'Crear Movimiento',
    formButtonTitle: 'Crear Movimiento',
    width: '3xl'
  },

  table: {
    columns: tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/movement/index',
    paginate: true,
    name: 'movimientos',
    actions: tableActions,
    details: true,
    detailsSlug: '/dashboard/administracion/movements/{{id}}',
    defaultSort: { column: 'movement_date', order: 'desc' }
  },

  useModalForm: false
};
